export const INIT_LOADING_IMAGES ="INIT_LOADING_IMAGES"
export const END_LOADING_IMAGES = "END_LOADING_IMAGES"
export const LOAD_IMAGES = "LOAD_IMAGES"
export const LOAD_CATEGORIES = "LOAD_CATEGORIES"
export const SET_SUB_CATEGORIES = "SET_SUB_CATEGORIES"
export const SET_CATEGORY = "SET_CATEGORY"
export const LOAD_ELEMENTS = "LOAD_ELEMENTS"
export const ERROR = "ERROR"